export const NumberFormatter = {
	currency: (locale = 'de-DE', currencyName = 'EUR') =>
		new Intl.NumberFormat(locale, {
			style: 'currency',
			currency: currencyName
		})
};
